import React from 'react'

const ActiveWear = () => {
  return (
    <div>ActiveWear</div>
  )
}

export default ActiveWear